import { PREDICTION, ACTUAL, COMBINED, SEEDATA, SCATTERPLOT_CHART, HISTOGRAM_CHART, PARALLEL_COORDINATES_CHART, LINE_CHART, BAR_CHART } from "../../Canvas/Constants";
import * as React from "react";
import { useState, useEffect} from "react";
import { extent as d3ArrayExtent, histogram } from "d3-array";
import { axisBottom as d3AxisBottom, axisLeft as d3AxisLeft } from "d3-axis";
import {
  min as d3min,
  max as d3max,
  schemeCategory10 as d3SchemeCategory10,
  event as d3event,
  brush as d3brush,
  brushSelection as d3brushSelection,
  select as d3select,
  mouse as d3mouse
} from "d3";
import {
  scaleLinear as d3ScaleLinear,
  scalePoint as d3ScalePoint,
  scaleOrdinal as d3ScaleOrdinal
} from "d3-scale";
import {
  select as d3Select,
  selectAll as d3SelectAll,
  event as currentEvent
} from "d3-selection";
import { line as d3Line, curveNatural } from "d3-shape";
import "../../../../css/ScatterPlot.css";
import * as aggregation from "../../aggregation/countAggregation";
import { func } from "prop-types";
import { fabric }  from "fabric";
import { GraphPredictContext } from "../../Canvas/GraphPredictContext";
import {
  histogramPredictionDataset,
  BrushingPointsScatterPlot,
  brushingDataset,
  PredictionPointsScatterPlot,
  BrushingDataSet
} from "../../../Globals/Globals";

import { histogramBrush } from "../../Brushing/HistogramBrush";
import { scatterPlotBrush } from "../../Brushing/ScatterPlotBrush";
import { lineChartBrush } from "../../Brushing/LineChartBrush";
import { parallelCoordinatesPlotBrush } from "../../Brushing/ParallelCoordinatesBrush";
import { barChartBrush } from "../../Brushing/BarChartBrush";
import {LogEvents} from '../../../Globals/Globals'
import  {getPointsAndIntersectingPaths} from '../../../../libjs/pointInSvgPath'
import {PREDICTION_COLOR,REALDATA_COLOR,BRUSHING_COLOR,NO_PREDICTION_COLOR} from "../../../Globals/ColorConstants"
import {clearAllBrushes} from '../../Canvas/MasterGraphConfig'
import {LOG_EVENT_TYPE_CHART_CREATED, LOG_EVENT_TYPE_CHART_DRAG_ENDED, LOG_EVENT_TYPE_CHART_DRAG_STARTED, LOG_EVENT_TYPE_CHART_DESTROYED, LOG_EVENT_TYPE_CHART_PREDICTION_CLEARED
  ,LOG_EVENT_TYPE_CHART_PREDICTION_ENDED, LOG_EVENT_TYPE_CHART_PREDICTION_STARTED, LOG_EVENT_TYPE_CHART_PREDICTION_PAGE, LOG_EVENT_TYPE_CHART_SEE_DATA_PAGE, LOG_EVENT_TYPE_CHART_BRUSHING_ENDED, 
  LOG_EVENT_TYPE_CHART_BRUSHING_STARTED, LOG_EVENT_TYPE_CHART_BRUSHING_CLICKED, LOG_EVENT_TYPE_CHART_BRUSHING_UNCLICKED, LOG_EVENT_TYPE_CHART_BRUSHING_CLEARED} from '../../../Globals/LogConstants'
  

  
interface ScatterPlotStates {}

interface ScatterPlotProps {
  xaxis: string;
  yaxis: string;
  height: number;
  width: number;
  id: string;
  brushValueOptions: {};
}

const ScatterPlot: React.FC<ScatterPlotProps> = ({
  id,
  width,
  height,
  xaxis,
  yaxis
}) => {
  const { grapVisOptions, setgrapVisOptions, graphFilter, clearOptions, setclearOptions } = GraphPredictContext();



  console.log('graphFilter',graphFilter)
  console.log("GraphPredictContextScatterPlot", grapVisOptions);
  var graphOptions = grapVisOptions["graphOptions"];
  var graphType = grapVisOptions["graphType"];

  var margin = { top: 10, right: 10, bottom: 60, left: 40 };
  var height = height - margin.left - margin.right;
  var width = width - margin.top - margin.bottom;

  var dataValues_x = aggregation.loadValues[xaxis];
  var dataValues_y = aggregation.loadValues[yaxis];
   const [clearUpdate, setclearUpdate] = useState(clearOptions)
   var canvas, cursor
   console.log('dataValues_x',dataValues_x,dataValues_x)

  



  var domainXMax = d3max(dataValues_x, function(d) {
    return +d;
  })
  var domainXMin =  Number.parseFloat(d3min(dataValues_x))

  var domainYMax = d3max(dataValues_y, function(d) {
    return +d;
  })
  
  var domainYMin =  Number.parseFloat(d3min(dataValues_y))
  
  domainYMax = domainYMax + domainYMax*0.1
  domainYMin = domainYMin - domainYMin*0.1

  var linearXScale = d3ScaleLinear()
    .range([0, width])
    .domain([
     domainXMin,
      domainXMax
    ]);
  const xAxis = d3AxisBottom(linearXScale);
  var linearYScale = d3ScaleLinear()
    .range([height, 0])
    .domain([
      domainYMin,
      domainYMax
    ]);
  const yAxis = d3AxisLeft(linearYScale);
  var realdata = aggregation.loadValues1;
  
  var tooltip = d3Select(id)
    .append("div")
    .attr("class", "tooltip")
    .style("opacity", 0);

  
  if(brushingDataset.getActualID(id) == null)
  {
    var actualDataset = brushingDataset.addActualID(id)
    
    actualDataset.setlinearYScale(linearYScale)
    actualDataset.setlinearXScale(linearXScale)
    actualDataset.height = height
    actualDataset.width = width
    actualDataset.domainMax = domainYMax
    actualDataset.domainMin = domainYMin
    actualDataset.xaxis = xaxis
    actualDataset.yaxis = yaxis
    actualDataset.type = SCATTERPLOT_CHART
    actualDataset.yAxis = yAxis
   
    
  }
  else
  {
    var actualDataset =  brushingDataset.getActualID(id)

    actualDataset.setlinearYScale(linearYScale)
    actualDataset.setlinearXScale(linearXScale)
    actualDataset.height = height
    actualDataset.width = width
    actualDataset.domainMax = domainYMax
    actualDataset.domainMin = domainYMin
    actualDataset.xaxis = xaxis
    actualDataset.yaxis = yaxis
    actualDataset.type = SCATTERPLOT_CHART
    actualDataset.yAxis = yAxis
  
  }

  React.useEffect(() => {

    if(graphOptions == SEEDATA)
    {

     
  
            
          if(BrushingDataSet.currentGraphType == HISTOGRAM_CHART)
          {
            
            histogramBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
          }
          if(BrushingDataSet.currentGraphType == SCATTERPLOT_CHART)
          {
            
            scatterPlotBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
          }
          if(BrushingDataSet.currentGraphType == BAR_CHART)
          {
            
            barChartBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
          }
          if(BrushingDataSet.currentGraphType == LINE_CHART)
          {
            
            lineChartBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
          }
          if(BrushingDataSet.currentGraphType == PARALLEL_COORDINATES_CHART)
          {
            
            parallelCoordinatesPlotBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData);
          }
          
        
      
    }

    if(graphOptions == '')
    {
      var dpr = window.devicePixelRatio || 1;
    
        console.log("graphOptionsgraphOptionsgraphOptions",graphOptions)
        if($('.'+id + "_svg_scatterplot_canvas").children().hasClass('canvas-container'))
        {
            console.log('second')
            brushingDataset.getActualID(id).fabricCanvas.setWidth(width)
            brushingDataset.getActualID(id).fabricCanvas.setHeight(height)
           
            brushingDataset.getActualID(id).fabricCanvas.clear()
            //brushingDataset.getActualID(id).fabricCanvas.backgroundColor = '#efefef';
        }
        else
        {
          console.log('graphFilter')
          canvas = new fabric.Canvas(id + "_canvas",{
            'isDrawingMode' : true,
            'freeDrawingCursor': 'none',
          
          })
          brushingDataset.getActualID(id).fabricCanvas = canvas

          document.getElementById(id + "_canvas").setAttribute('height',height.toString())
          document.getElementById(id + "_canvas").setAttribute('width',width.toString())
        
    
          if(histogramPredictionDataset.getPredictionScatterPlot(id + "_canvas") == null)
          {
            var scatterplotPrediction = histogramPredictionDataset.addPredictionScatterPlot(id + "_canvas")
            scatterplotPrediction.fabricCanvasInst = canvas
       
          }
          else
          {

            var scatterplotPrediction = histogramPredictionDataset.getPredictionScatterPlot(id + "_canvas")
          
            var strDataURI =  scatterplotPrediction.imageURI
        
            var img = new window.Image();
            img.addEventListener("load", function () {
              canvas.getContext().drawImage(img, 0, 0);
            });
            img.setAttribute("src", strDataURI);
            
            scatterplotPrediction.fabricCanvasInst = canvas
         
          }
        }
    }
    if(graphOptions == PREDICTION)
    {
      var dpr = window.devicePixelRatio || 1;
    

      if($('.'+id + "_svg_scatterplot_canvas").children().hasClass('canvas-container'))
      {
          console.log('second')
          brushingDataset.getActualID(id).fabricCanvas.clear()
          brushingDataset.getActualID(id).fabricCanvas.setWidth(width)
          brushingDataset.getActualID(id).fabricCanvas.setHeight(height)
          brushingDataset.getActualID(id).fabricCursor.setWidth(width)
          brushingDataset.getActualID(id).fabricCursor.setHeight(height)
          brushingDataset.getActualID(id).fabricCanvas.backgroundColor = '#efefef';


          var  mousecursor1 = brushingDataset.getActualID(id).mouseCursor
          brushingDataset.getActualID(id).fabricCanvas.on('mouse:move', function (evt) {
            var mouse = this.getPointer(evt.e);  
            
            mousecursor1
              .set({
                top: mouse.y,
                left: mouse.x
              })
              .setCoords()
              .canvas.renderAll();
          });
    
      
          brushingDataset.getActualID(id).fabricCanvas.on('mouse:out', function (evt) {
        
            mousecursor1
              .set({
                top:  -100,
                left:  -100
              })
              .setCoords()
              .canvas.renderAll();
    
          });
          
          document.getElementById(id + "_canvas").setAttribute('height',height.toString())
          document.getElementById(id + "_canvas").setAttribute('width',width.toString())
          
          var scatterplotPrediction = histogramPredictionDataset.getPredictionScatterPlot(id + "_canvas")
          
            var strDataURI =  scatterplotPrediction.imageURI
        
            var img = new window.Image();
            img.addEventListener("load", function () {
              canvas.getContext().drawImage(img, 0, 0);
            });
            img.setAttribute("src", strDataURI);
            

      }
      else
      {
          console.log('graphFilter')
          canvas = new fabric.Canvas(id + "_canvas",{
            'isDrawingMode' : true,
            'freeDrawingCursor': 'none',
          
          })
          brushingDataset.getActualID(id).fabricCanvas = canvas
          canvas.freeDrawingBrush.width = 20;
          canvas.freeDrawingBrush.color = PREDICTION_COLOR;
          cursor = new fabric.StaticCanvas(id + "_cursor");
        
          var cursorOpacity = .5;
          var mousecursor = new fabric.Circle({ 
            left: -100, 
            top: -100, 
            radius: canvas.freeDrawingBrush.width / 2, 
            fill: PREDICTION_COLOR, 
            stroke: "black",
            originX: 'center', 
            originY: 'center',
          
          });
          brushingDataset.getActualID(id).fabricCursor = cursor
          cursor.add(mousecursor)
          cursor.setWidth(width)
          cursor.setHeight(height)
    
          canvas.backgroundColor = '#efefef';
      
          canvas.setWidth(width)
          canvas.setHeight(height)
          var down = false;
          
          brushingDataset.getActualID(id).mouseCursor = mousecursor
        
          
          canvas.on('mouse:move', function (evt) {
            var mouse = this.getPointer(evt.e);  
            
            mousecursor
              .set({
                top: mouse.y,
                left: mouse.x
              })
              .setCoords()
              .canvas.renderAll();
          });
    
      
        canvas.on('mouse:out', function (evt) {
        
            mousecursor
              .set({
                top:  -100,
                left:  -100
              })
              .setCoords()
              .canvas.renderAll();
    
          });
          
          document.getElementById(id + "_canvas").setAttribute('height',height.toString())
          document.getElementById(id + "_canvas").setAttribute('width',width.toString())
        
    
          if(histogramPredictionDataset.getPredictionScatterPlot(id + "_canvas") == null)
          {
            var scatterplotPrediction = histogramPredictionDataset.addPredictionScatterPlot(id + "_canvas")
            scatterplotPrediction.fabricCanvasInst = canvas
            scatterplotPrediction.fabricCursorInst = cursor
            scatterplotPrediction.mouseCursor = mousecursor
          }
          else
          {
            var scatterplotPrediction = histogramPredictionDataset.getPredictionScatterPlot(id + "_canvas")
          
            var strDataURI =  scatterplotPrediction.imageURI
        
            var img = new window.Image();
            img.addEventListener("load", function () {
              canvas.getContext().drawImage(img, 0, 0);
            });
            img.setAttribute("src", strDataURI);
            
            scatterplotPrediction.fabricCanvasInst = canvas
            scatterplotPrediction.fabricCursorInst = cursor
            scatterplotPrediction.mouseCursor = mousecursor
          }
      }

     
     
      
    }


    
   
  }, [graphOptions, graphType, width, height, xaxis, yaxis]);
  if (graphOptions == '') {

    const canvasStyle = {
      position: 'absolute',
      top:10+'px',
      left:41+'px'

    } as React.CSSProperties;
    return (
      <>
        <svg
          id={id + "_svg_barchar_draw"}
          className={id + "chart"}
          height={height + margin.left + margin.right}
          width={width + margin.top + margin.bottom}
        >
          <g transform={"translate(" + margin.left + ", " + margin.top + ")"}>
            <g transform={"translate(0," + height + ")"}>
              <g
                transform={"translate(0,0)"}
                ref={node => d3Select(node).call(xAxis)}
              ></g>
            </g>
  
            <g ref={node => d3Select(node).call(yAxis)}></g>
          </g>
        </svg>
        <div className={id + "_svg_scatterplot_canvas"} style={canvasStyle} >
          <canvas id={id + "_canvas"} ></canvas>
          <canvas id={id + "_cursor"} style={{pointerEvents: "none"}}></canvas>
       </div>
      </>
      );
  }
   
 
  
  if (graphOptions == PREDICTION) {
    const canvasStyle = {
      position: 'absolute',
      top:10+'px',
      left:41+'px'

    } as React.CSSProperties;

 
  

    return (
    <>
      <svg
        id={id + "_svg_barchar_draw"}
        className={id + "chart"}
        height={height + margin.left + margin.right}
        width={width + margin.top + margin.bottom}
      >
        <g transform={"translate(" + margin.left + ", " + margin.top + ")"}>
          <g transform={"translate(0," + height + ")"}>
            <g
              transform={"translate(0,0)"}
              ref={node => d3Select(node).call(xAxis)}
            ></g>
          </g>

          <g ref={node => d3Select(node).call(yAxis)}></g>
        </g>
      </svg>
      <div className={id + "_svg_scatterplot_canvas"} style={canvasStyle} >
        <canvas id={id + "_canvas"} ></canvas>
        <canvas id={id + "_cursor"} style={{pointerEvents: "none"}}></canvas>
     </div>
    </>
    );
  }
  if (graphOptions == SEEDATA) {

  

    var points
    var predictionPointsScatterPlot = histogramPredictionDataset.getPredictionScatterPlot(id + "_canvas")
    if(predictionPointsScatterPlot)
    {
      
      var dataImage = ''
      var predictionPoints = []
      var predictionIds = new Array<string>()
      predictionPointsScatterPlot.imageData.restore()
      console.log('window.devicePixelRatio',window.devicePixelRatio)
      points = realdata.map(function(d, i) {
        var xCord = Math.round(linearXScale(d[xaxis]))
        var yCord = Math.round(linearYScale(d[yaxis]))
        //var colorIndices = getColorIndicesForCoord(xCord, yCord, width);
       
        var rgb = predictionPointsScatterPlot.imageData.getImageData(xCord,yCord,window.devicePixelRatio,window.devicePixelRatio).data
        
      
        if(predictionPointsScatterPlot!=null && rgb[0] != 239 && rgb[0] != 0)
        {
          dataImage = predictionPointsScatterPlot.imageURI
          predictionPoints.push({x:linearXScale(d[xaxis]),y:linearYScale(d[yaxis])})
          predictionIds.push(d['ID'].toString())
          return (
            <>
              <circle
                r={3.5}
                cx={linearXScale(d[xaxis])}
                cy={linearYScale(d[yaxis])}
                id={id + "_" + d['ID']}
                style={{ opacity: 0.5, fill: PREDICTION_COLOR, stroke:'black'}}
                className={id + "_svg_scatterplot_draw_g_circle "+SCATTERPLOT_CHART+" "+SCATTERPLOT_CHART+"_"+d["Origin"]+" ScatterPlotChart_Origin_"+xaxis+"_"+d["Origin"]+" ScatterPlotChart_Origin_"+yaxis+"_"+d["Origin"]+" ScatterPlotChart_Origin_"+d["Origin"]+" ScatterPlotChart_"+xaxis+" ScatterPlotChart_"+yaxis }
              ></circle>
            
            </>
          );
        
        }
        else
        {
          return (
            <>
              <circle
                r={3}
                cx={linearXScale(d[xaxis])}
                cy={linearYScale(d[yaxis])}
                id={id + "_" + d['ID']}
  
                style={{ opacity: 0.5, fill: REALDATA_COLOR}}
                className={id + "_svg_scatterplot_draw_g_circle "+SCATTERPLOT_CHART+" "+SCATTERPLOT_CHART+"_"+d["Origin"]+" ScatterPlotChart_Origin_"+xaxis+"_"+d["Origin"]+" ScatterPlotChart_Origin_"+yaxis+"_"+d["Origin"]+" ScatterPlotChart_Origin_"+d["Origin"]+" ScatterPlotChart_"+xaxis+" ScatterPlotChart_"+yaxis }
              ></circle>
            
            </>
          );
        }
           
        
       
      })
      console.log('predictionPoints',predictionPoints)
      predictionPointsScatterPlot.predictionPoints = predictionPoints
      predictionPointsScatterPlot.predictionIds = predictionIds
      if(predictionPoints.length>0)
      {
        var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
        if(logevents)
        {
            var eventlog = LogEvents.addEvent(id, SCATTERPLOT_CHART, PREDICTION,LOG_EVENT_TYPE_CHART_PREDICTION_STARTED, predictionPoints, null,xaxis,yaxis,null)
            logevents._logEvents.push(eventlog)
            sessionStorage.setItem('logevents', JSON.stringify(logevents))
        }
      }
     
    }
    else
    {
      points = realdata.map(function(d, i) {
        var xCord = Math.round(linearXScale(d[xaxis]))
        var yCord = Math.round(linearYScale(d[yaxis]))

        return (
          <>
            <circle
              r={3}
              cx={linearXScale(d[xaxis])}
              cy={linearYScale(d[yaxis])}
              id={id + "_" + d['ID']}

              style={{ opacity: 0.5, fill: REALDATA_COLOR}}
              className={id + "_svg_scatterplot_draw_g_circle "+SCATTERPLOT_CHART+" "+SCATTERPLOT_CHART+"_"+d["Origin"]+" ScatterPlotChart_Origin_"+xaxis+"_"+d["Origin"]+" ScatterPlotChart_Origin_"+yaxis+"_"+d["Origin"]+" ScatterPlotChart_Origin_"+d["Origin"]+" ScatterPlotChart_"+xaxis+" ScatterPlotChart_"+yaxis }
            ></circle>
          
          </>
        );
      })
    }
   
      

    var brush_coords_move;
    var brush = d3brush()
  
      .extent([[0, 0], [width, height]])
      .on("start", function() {
      
        
        var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
        if(logevents)
          {
            var eventlog = LogEvents.addEvent(id, SCATTERPLOT_CHART, SEEDATA,LOG_EVENT_TYPE_CHART_BRUSHING_STARTED, null, null,xaxis,yaxis,null)
            logevents._logEvents.push(eventlog)
            sessionStorage.setItem('logevents', JSON.stringify(logevents))
          }

        if(BrushingDataSet.currentGraphID!=id)
        {
        clearAllBrushes()
        }
      })
      .on("end", function() {

        

        var brush_coords = d3brushSelection(this);

        var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
        if(logevents)
          {
            var eventlog = LogEvents.addEvent(id, SCATTERPLOT_CHART, SEEDATA, LOG_EVENT_TYPE_CHART_BRUSHING_ENDED, null, brush_coords,xaxis,yaxis,null)
            logevents._logEvents.push(eventlog)
            sessionStorage.setItem('logevents', JSON.stringify(logevents))
          }

        console.log("var brush_coords", brush_coords);
        if (brush_coords == null) {
          brushingDataset.emptyBrushingScatterPlotArray();

          BrushingDataSet.currentGraphID = id
          BrushingDataSet.currentGraphType = SCATTERPLOT_CHART
          BrushingDataSet.currentGraphData = "none"
          BrushingDataSet.currentGraphEnable = 2
          BrushingDataSet.currentGraphBrushInstance = brush

          scatterPlotBrush(2, id, "none", brushingDataset);
          d3SelectAll("." + id + "_svg_scatterplot_draw_g_circle").classed(
            "selected",
            function() {
              return false;
            }
          );
        }
       
      })
      .on("brush", function() {
      

        brush_coords_move = d3brushSelection(this);
        if(brush_coords_move!=null)
        {
          brushingDataset.getBrushingScatterPlotAxis().xaxis = xaxis;
          brushingDataset.getBrushingScatterPlotAxis().yaxis = yaxis;
          brushingDataset.getBrushingScatterPlotAxis().linearXScale = linearXScale;
          brushingDataset.getBrushingScatterPlotAxis().linearYScale = linearYScale;
  
          var changedX = this.getAttribute("data-x");
          var changedY = this.getAttribute("data-y");
  
         
          d3SelectAll("." + id + "_svg_scatterplot_draw_g_circle").classed(
            "selected",
            function() {
              var cx = d3select(this).attr("cx"),
                cy = d3select(this).attr("cy");
              return isBrushed(brush_coords_move, cx, cy);
            }
          );
          brushingDataset.emptyBrushingScatterPlotArray();
         
          var brushingPointsScatterPlotArray = brushingDataset.getBrushingScatterPlotArray();
          d3SelectAll("." + id + "_svg_scatterplot_draw_g_circle.selected").each(
            function(d) {
              var cx = d3select(this).attr("cx"),
                cy = d3select(this).attr("cy");
              var brushingPointsScatterPlot = new BrushingPointsScatterPlot();
              brushingPointsScatterPlot.pointX = linearXScale.invert(
                parseFloat(cx)
              );
              brushingPointsScatterPlot.pointY = linearYScale.invert(
                parseFloat(cy)
              );
              
              brushingPointsScatterPlot.dataID = d3select(this)
                .attr("id")
                .split("_")[
                d3select(this)
                  .attr("id")
                  .split("_").length - 1
              ];
              brushingPointsScatterPlotArray.push(brushingPointsScatterPlot);
            }
          );
         
  
          BrushingDataSet.currentGraphID = id
          BrushingDataSet.currentGraphType = SCATTERPLOT_CHART
          BrushingDataSet.currentGraphData = brushingPointsScatterPlotArray
          BrushingDataSet.currentGraphEnable = 0
          BrushingDataSet.currentGraphBrushInstance = brush
  
          scatterPlotBrush(
            0,
            id,
            brushingPointsScatterPlotArray,
            brushingDataset
          );
        }
       
      });



    /*  React.useEffect(() => {
        console.log("useEffectScatterPlot");
      
      

    }, [graphType, graphOptions, width, height]);
*/
    return (
      <>
        {""}
        <svg
          id={id + "_svg_barchar_draw"}
          className={id + "chart"}
          height={height + margin.left + margin.right}
          width={width + margin.top + margin.bottom}
        >
          <image width={width} height={height} xlinkHref={dataImage} x={margin.left} y ={margin.top} style={{opacity: 0.5}}/>
          <g
            transform={"translate(" + margin.left + ", " + margin.top + ")"}
            className={id + "_svg_scatterplot_draw_g"  }
            ref={node => d3Select(node).call(brush)}
          >
            <g transform={"translate(0," + height + ")"}>
              <g
                transform={"translate(0,0)"}
                ref={node => d3Select(node).call(xAxis)}
              ></g>
            </g>

            <g ref={node => d3Select(node).call(yAxis)} ></g>

            {points}
            
          </g>
        </svg>
      </>
    );
  }

 
};
export default ScatterPlot;

function isBrushed(brush_coords, cx, cy) {
  var x0 = brush_coords[0][0],
    x1 = brush_coords[1][0],
    y0 = brush_coords[0][1],
    y1 = brush_coords[1][1];
  return x0 <= cx && cx <= x1 && y0 <= cy && cy <= y1;
}

function getMousePos(canvas, evt) {
  var rect = canvas.getBoundingClientRect();
  console.log('rect',rect,evt.clientX,evt.clientY)
  return {
      x: (evt.clientX - rect.left) / (rect.right - rect.left) * canvas.width,
      y: (evt.clientY - rect.top) / (rect.bottom - rect.top) * canvas.height
  };
}

function getColorIndicesForCoord1(x, y, width) {
  var red = y * (width) + x;
  return [red, red + 1, red + 2, red + 3];

}
function getColorIndicesForCoord(x, y, width) {
  var red = y * (width*4) + x * 4;
  return [red, red + 1, red + 2, red + 3];
}


function arr_diff (a1, a2) {

  var a = [], diff = [];

  for (var i = 0; i < a1.length; i++) {
      a[a1[i]] = true;
  }

  for (var i = 0; i < a2.length; i++) {
      if (a[a2[i]]) {
          delete a[a2[i]];
      } else {
          a[a2[i]] = true;
      }
  }

  for (var k in a) {
      diff.push(k);
  }

  return diff;
}
{
  /* <svg id={"chart"}
x = {0.2375*this.props.height}
y = {0}

height = {this.props.height}
width = {this.props.width}

>

<g transform={"translate("+0.078125*this.props.width+", "+0.03125*this.props.width+ ")"}
   >

        <g  ref={node => d3Select(node).call(yAxis) }  />
        
        <g
        
                ref={node => d3Select(node).call(xAxis)}
                transform={"translate(0, "+ 0.905*this.props.width + ")"}
        >
        
        </g>

        {points}
</g>

</svg> */
}
